module.exports = __webpack_public_path__ + "static/media/01_Alex_orange.1758b967.png";